const signalR = require("@microsoft/signalr");
const { getJwtToken } = require("./plugins/client");

let connection;
let isConnected = false;

exports.connectToSocket = cb => {
  connection = new signalR.HubConnectionBuilder()
    .withUrl(process.env.VUE_APP_HUB_URL, {
      transport: signalR.HttpTransportType.WebSockets,
      accessTokenFactory: () => getJwtToken()
    })
    .withAutomaticReconnect()
    .build();

  async function start() {
    try {
      await connection.start();
      console.log("hub connected");
      isConnected = true;
      cb();
    } catch (err) {
      console.log(err);
      setTimeout(start, 5000);
      isConnected = false;
    }
  }

  start();

  connection.onclose(() => {
    isConnected = false;
  });
};

exports.broadcastEvent = (type, projectId, payload) => {
  const input = {
    type,
    projectId,
    ...payload
  };
  console.log("[hub] broadcasting event for:", type, projectId, input);
  isConnected && connection.invoke("BroadcastEvent", input);
};

exports.joinProjectGroup = projectId => {
  console.log("joinProjectGroup projectId", projectId);
  isConnected && connection.invoke("JoinProjectGroup", projectId);
};

exports.leaveProjectGroup = projectId => {
  console.log("leaveProjectGroup projectId", projectId);
  isConnected && connection.invoke("LeaveProjectGroup", projectId);
};

exports.joinPage = (projectId, pageId) => {
  console.log("joinPage projectId", projectId, pageId);
  isConnected && connection.invoke("JoinPage", projectId, pageId);
};

exports.getOnlineUsers = projectId => {
  console.log("getOnlineUsers projectId", projectId);
  isConnected && connection.invoke("GetOnlineUsers", projectId);
};

exports.on = (event, cb) => {
  console.log("on subscribed to ", event);
  isConnected && connection.on(event, cb);
};
